<script setup lang="ts">
  interface Emits {
    (event: "update:playbackRate", playbackRate: number): void;
    (event: "onMenuSwitch", value: boolean): void;
  }
  interface Props {
    playbackRate: number;
    width: number;
    disabled?: boolean;
  }
  const localProps = withDefaults(defineProps<Props>(), {
    playbackRate: 1,
    width: 24,
    disabled: false,
  });
  const emit = defineEmits<Emits>();

  const computedData = computed<number>({
    get: () => {
      return localProps.playbackRate;
    },
    set: (value: number) => {
      emit("update:playbackRate", value);
    },
  });
  const items = [
    { title: "0.75x", value: 0.75 },
    { title: "標準", value: 1 },
    { title: "1.25x", value: 1.25 },
    { title: "1.5x", value: 1.5 },
    { title: "1.75x", value: 1.75 },
    { title: "2x", value: 2 },
  ];
  const padding = 8;
</script>

<template>
  <v-sheet>
    <v-menu location="top" @update:model-value="val => $emit('onMenuSwitch', val)">
      <template #activator="{ props }">
        <div class="container">
          <AtomsSvgIcon
            class="icon-button"
            :width="width - padding"
            img-path="assets/images/icon/gear.svg"
            v-bind="props"
          />
        </div>
      </template>
      <div class="popup">
        <div class="list">
          <div class="list-item px-4">
            <span class="font-weight-bold">再生速度</span>
            <v-icon icon="$mdiClose" :size="16" />
          </div>
          <div v-for="(item, index) in items" :key="index">
            <div
              class="list-item"
              :class="{ active: item.value == computedData }"
              @click="computedData = item.value"
            >
              <span class="list-item-icon">
                <v-icon v-if="item.value == computedData" icon="$mdiCheck" :size="20" />
              </span>
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-menu>
  </v-sheet>
</template>
<style lang="scss" scoped>
  .container {
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
    border-radius: 30px;
    background-color: rgba(54, 30, 255, 0.3) !important;
  }
  .icon-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .popup {
    padding-bottom: 30px;
  }
  .list {
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
    padding: 5px 0;
    background: rgba($color: #161616, $alpha: 0.5);
  }
  .list-item {
    padding: 5px 10px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: baseline;
    gap: 5px;
  }
  .list-item.active {
    color: rgb(var(--v-theme-primary));
  }
  .list-item-icon {
    width: 20px;
    height: 20px;
  }
</style>
